import { render, staticRenderFns } from "./map-legend.vue?vue&type=template&id=1d0895ba&scoped=true&"
import script from "./map-legend.vue?vue&type=script&lang=js&"
export * from "./map-legend.vue?vue&type=script&lang=js&"
import style0 from "./map-legend.vue?vue&type=style&index=0&id=1d0895ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d0895ba",
  null
  
)

export default component.exports